import { ContextSystem } from '@/components/menu/ContextSystem/ContextSystem';
import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors';
import { getUserRoles } from '@/store/global/userRoles/selectors';

export default function ContextSystemPage() {
  const user = useGlobalStore(getUser);
  const userRoles = useGlobalStore(getUserRoles);

  return <ContextSystem user={user.toJSON()} userRoles={userRoles} />;
}
